// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';

// 导入页面组件
import LoginPage from '@/components/LoginPage.vue';
import RegisterPage from '@/components/RegisterPage.vue';
import CoinRecord from '@/components/CoinRecord.vue';
import GameRecord from '@/components/GameRecord.vue';
import DepositPage from '@/components/DepositPage.vue';
import WithdrawPage from '@/components/WithdrawPage.vue';
import WithdrawTX from '@/components/WithdrawTX.vue';
import CS from '@/components/CS.vue';



const routes = [
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
    meta: { 
      title: '登录'
    }
  },
  {
    path: '/register',
    name: 'RegisterPage',
    component: RegisterPage,
    meta: { 
      title: '注册'
    }
  },
  {
    path: '/coinrecord',
    name: 'CoinRecord',
    component: CoinRecord,
    meta: { 
      title: '金币记录',
      showNav:true
    }
  },
  {
    path: '/gamerecord',
    name: 'GameRecord',
    component: GameRecord,
    meta: { 
      title: '游戏记录',
      showNav:true
    }
  },
  {
    path: '/deposit',
    name: 'DepositPage',
    component: DepositPage,
    meta: { 
      title: '充USDT',
      showNav:false
    }
  },
  {
    path: '/withdraw',
    name: 'WithdrawPage',
    component: WithdrawPage,
    meta: { 
      title: '提USDT',
      showNav:false
    }
  },  
  {
    path: '/withdrawtx',
    name: 'WithdrawTX',
    component: WithdrawTX,
    meta: { 
      title: '提U记录',
      showNav:true
    }
  },
  {
    path: '/cs',
    name: 'CS',
    component: CS,
    meta: { 
      title: '客服',
      showNav:false
    }
  },
  {
    path: '/',
    redirect: 'login'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  // 设置标题
  document.title = to.meta.title || '默认标题'; // 回退默认值
  next();
});

export default router;